import type { SVGProps } from "react";
export interface FileHeartIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function FileHeartIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: FileHeartIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M2.875 19V5A4.125 4.125 0 0 1 7 .875h6.586c.293 0 .58.063.844.177l.022.009q.258.115.48.296l.157.14 5.414 5.415c.18.18.322.39.426.618q.012.022.022.047c.113.262.174.547.174.838V19A4.125 4.125 0 0 1 17 23.125H7A4.125 4.125 0 0 1 2.875 19m12.25-13c0 .484.392.875.875.875h1.285l-2.16-2.16zm-10 13c0 1.035.84 1.875 1.875 1.875h10c1.036 0 1.875-.84 1.875-1.875V9.125H16A3.125 3.125 0 0 1 12.876 6V3.125H7c-1.036 0-1.875.84-1.875 1.875z"
      />
      <path
        fill={color}
        d="M13.957 10.375c.936 0 1.747.48 2.29 1.102a3.52 3.52 0 0 1 .873 2.408l.002.001c-.037 1.226-.759 2.166-1.42 2.852l-.278.28c-.49.48-.96.924-1.365 1.3l-.98.897a1.615 1.615 0 0 1-2.04.099l-.118-.099c-.35-.314-.944-.853-1.633-1.509l-.715-.688c-.719-.703-1.656-1.73-1.698-3.132l.001-.001a3.53 3.53 0 0 1 .875-2.408c.543-.623 1.353-1.102 2.288-1.102.866 0 1.5.308 1.959.688.458-.38 1.093-.688 1.96-.688Zm0 2.25c-.293 0-.459.102-.587.229a1.4 1.4 0 0 0-.202.26l-.157.295v.001l-.025.044a1 1 0 0 1-.199.262 1.1 1.1 0 0 1-.299.217 1.1 1.1 0 0 1-.38.103 1.1 1.1 0 0 1-.323-.015 1 1 0 0 1-.152-.038q-.004 0-.007-.002a1 1 0 0 1-.118-.046l-.067-.037-.015-.009a1.1 1.1 0 0 1-.214-.17 1.1 1.1 0 0 1-.178-.221l-.02-.04q-.016-.023-.027-.048l-.002-.001c-.097-.203-.2-.4-.357-.556-.128-.126-.295-.228-.589-.228-.148 0-.377.084-.593.331a1.3 1.3 0 0 0-.32.747l-.002.113v.003l.019.161c.073.38.372.813 1.003 1.43l.693.668c.439.417.84.784 1.159 1.075a74 74 0 0 0 1.853-1.743l.25-.254c.539-.567.761-.969.772-1.337v-.003l-.003-.113a1.3 1.3 0 0 0-.32-.747c-.215-.247-.445-.331-.593-.331"
      />
    </svg>
  );
}
